import {htmlToText} from 'html-to-text'
export default (html,options={})=>htmlToText(html,options)
